export default "__VITE_ASSET__9add65ea__"